module.exports = __webpack_public_path__ + "img/rep-05-new.b4f83828.png";